import GSAP from 'gsap';
import Page from '@averyano/core/src/classes/Page';
import ScrollTrigger from 'gsap/ScrollTrigger';
import each from 'lodash/each';

import Lightbox from '../../components/Lightbox';

export default class CasePage extends Page {
	constructor(el) {
		super({
			element: '.case',
			elements: {
				wrapper: '.case__wrapper',
				// One selector for every lightboxable figure: Lightbox.create() snapshots the
				// array once, so galleries and videos must arrive together.
				lightboxItems: '[data-lightbox]',
			},
		});

		this.id = 'case';
		this.isCreated = false;
		this.currentCase = null;
		this.lightbox = new Lightbox();
		this.onGalleryClick = [];
	}

	create() {
		if (this.template !== this.id) return;
		if (!this.isReady) super.createComponent();
		if (!this.isCreated) {
			this.components = {};
			this.isCreated = true;
		}

		super.create();

		this.itemId = this.element.dataset.id;
		this.currentCase = CASES.find((c) => c.id === this.itemId);

		if (this.elements.lightboxItems && this.elements.lightboxItems.length) {
			this.lightbox.create(this.elements.lightboxItems);
		}

		this.addEventListeners();
	}

	openLightbox(item) {
		this.lightbox.setActiveImage(item);
		this.lightbox.open();
	}

	destroy() {
		this.scrollTrigger?.kill();
		this.removeEventListeners();
		super.destroy();
	}

	show() {
		GSAP.to(this.element, {
			autoAlpha: 1,
			duration: 1.5,
			ease: 'power2.out',
		});

		window.scrollTo(0, 0);
	}

	hide() {
		return new Promise((resolve) => {
			ScrollTrigger.getAll().forEach((t) => t.kill());
			GSAP.to(this.element, {
				autoAlpha: 0,
				duration: 1.5,
				ease: 'expo.out',
				onComplete: resolve,
			});
		});
	}

	update() {}

	addEventListeners() {
		if (!this.elements.lightboxItems || !this.elements.lightboxItems.length)
			return;

		each(this.elements.lightboxItems, (item) => {
			const handler = () => this.openLightbox(item);
			this.onGalleryClick.push({ item, handler });
			item.addEventListener('click', handler);
		});
	}

	removeEventListeners() {
		each(this.onGalleryClick, ({ item, handler }) => {
			item.removeEventListener('click', handler);
		});
		this.onGalleryClick = [];
	}
}
